<template>

  <!-- =========================================================
       SNACKBAR
  ========================================================== -->

  <Transition name="snackbar">
    <div
      v-if="showSnackbarFlag"
      :class="[
        'snackbar',
        snackbarError
          ? 'snackbar-error'
          : 'snackbar-success'
      ]"
    >
      <div class="snackbar-icon">
        {{ snackbarError ? "!" : "✓" }}
      </div>

      <span>
        {{ snackbarMessage }}
      </span>
    </div>
  </Transition>


  <!-- =========================================================
       PAGE
  ========================================================== -->

  <div class="create-event-page">

    <DefaultHeader
      title="Создание ивента"
      class="fixed-header"
      subtitle="Заполните все поля и создайте ваш ивент"
      :offset="690"
    />


    <main class="create-event-content">

      <div class="create-event-container">

        <!-- =====================================================
             HEADING
        ====================================================== -->

        <section class="page-heading">

          <div>
            <span class="page-label">
              Новый ивент
            </span>

            <h1>
              Создайте событие
            </h1>

            <p>
              Заполните информацию об ивенте.
              После отправки событие попадёт на модерацию.
            </p>
          </div>


          <div class="moderation-info">

            <span class="moderation-dot"></span>

            <div>
              <strong>
                Модерация
              </strong>

              <span>
                Перед публикацией
              </span>
            </div>

          </div>

        </section>


        <!-- =====================================================
             EDITOR
        ====================================================== -->

        <div class="editor-layout">


          <!-- ===================================================
               LEFT
          ==================================================== -->

          <section class="form-column">

            <!-- MAIN -->

            <div class="editor-card">

              <div class="card-heading">

                <div class="card-heading-icon main-icon">

                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M5 6.5C5 5.67 5.67 5 6.5 5H17.5C18.33 5 19 5.67 19 6.5V17.5C19 18.33 18.33 19 17.5 19H6.5C5.67 19 5 18.33 5 17.5V6.5Z"
                      stroke="currentColor"
                      stroke-width="1.7"
                    />

                    <path
                      d="M8 9H16"
                      stroke="currentColor"
                      stroke-width="1.7"
                      stroke-linecap="round"
                    />

                    <path
                      d="M8 12H14"
                      stroke="currentColor"
                      stroke-width="1.7"
                      stroke-linecap="round"
                    />

                    <path
                      d="M8 15H12"
                      stroke="currentColor"
                      stroke-width="1.7"
                      stroke-linecap="round"
                    />
                  </svg>

                </div>


                <div>
                  <h2>
                    Основная информация
                  </h2>

                  <p>
                    Название и описание события
                  </p>
                </div>

              </div>


              <!-- TITLE -->

              <div class="form-group">

                <div class="label-row">

                  <label>
                    Название
                  </label>

                  <span
                    class="field-counter"
                    :class="{
                      warning:
                        form.title.length > 80
                    }"
                  >
                    {{ form.title.length }}/100
                  </span>

                </div>


                <input
                  v-model="form.title"
                  maxlength="100"
                  type="text"
                  placeholder="Например: HR Meetup Moscow"
                />

              </div>


              <!-- DESCRIPTION -->

              <div class="form-group">

                <div class="label-row">
                  <label>
                    Описание
                  </label>
                </div>

                <textarea
                  v-model="form.description"
                  rows="7"
                  placeholder="Расскажите, о чём событие, для кого оно и почему стоит прийти..."
                ></textarea>

              </div>

            </div>


            <!-- DATE + LINK -->

            <div class="editor-card">

              <div class="card-heading">

                <div class="card-heading-icon date-icon">

                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <rect
                      x="4"
                      y="5"
                      width="16"
                      height="15"
                      rx="3"
                      stroke="currentColor"
                      stroke-width="1.7"
                    />

                    <path
                      d="M8 3V7"
                      stroke="currentColor"
                      stroke-width="1.7"
                      stroke-linecap="round"
                    />

                    <path
                      d="M16 3V7"
                      stroke="currentColor"
                      stroke-width="1.7"
                      stroke-linecap="round"
                    />

                    <path
                      d="M4 9H20"
                      stroke="currentColor"
                      stroke-width="1.7"
                    />
                  </svg>

                </div>


                <div>
                  <h2>
                    Дата и ссылка
                  </h2>

                  <p>
                    Когда проходит событие и где узнать больше
                  </p>
                </div>

              </div>


              <div class="two-column-fields">

                <div class="form-group">

                  <label>
                    Дата проведения
                  </label>

                  <input
                    v-model="form.dateOfEvent"
                    type="date"
                  />

                </div>


                <div class="form-group">

                  <label>
                    Ссылка на ивент
                  </label>

                  <div class="input-with-icon">

                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M10 14L14 10"
                        stroke="currentColor"
                        stroke-width="1.7"
                        stroke-linecap="round"
                      />

                      <path
                        d="M8 16L6.5 17.5C4.84 19.16 2.16 19.16 0.5 17.5C-1.16 15.84 -1.16 13.16 0.5 11.5L4 8C5.66 6.34 8.34 6.34 10 8"
                        stroke="currentColor"
                        stroke-width="1.7"
                        stroke-linecap="round"
                      />

                      <path
                        d="M16 8L17.5 6.5C19.16 4.84 21.84 4.84 23.5 6.5C25.16 8.16 25.16 10.84 23.5 12.5L20 16C18.34 17.66 15.66 17.66 14 16"
                        stroke="currentColor"
                        stroke-width="1.7"
                        stroke-linecap="round"
                      />
                    </svg>

                    <input
                      v-model="form.linkURL"
                      type="text"
                      placeholder="https://..."
                    />

                  </div>

                </div>

              </div>

            </div>


            <!-- CITY + COMPANY -->

            <div class="editor-card">

              <div class="card-heading">

                <div class="card-heading-icon company-icon">

                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M5 20V8L12 4L19 8V20"
                      stroke="currentColor"
                      stroke-width="1.7"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />

                    <path
                      d="M9 20V14H15V20"
                      stroke="currentColor"
                      stroke-width="1.7"
                    />
                  </svg>

                </div>


                <div>
                  <h2>
                    Организатор
                  </h2>

                  <p>
                    Выберите город и компанию
                  </p>
                </div>

              </div>


              <div class="autocomplete-field">

                <CityAutocompleteForEvent
                  v-model="selectedCity"
                />

              </div>


              <div class="autocomplete-field">

                <CompanyAutocompleteForEvent
                  v-model="selectedCompany"
                />

              </div>

            </div>

          </section>


          <!-- ===================================================
               RIGHT
          ==================================================== -->

          <aside class="preview-column">

            <div class="preview-sticky">

              <div class="preview-label-row">

                <span class="preview-label">
                  Обложка события
                </span>

                <span
                  v-if="imageUrl"
                  class="image-ready"
                >
                  <span></span>
                  Загружено
                </span>

              </div>


              <!-- IMAGE -->

              <div
                class="image-upload-card"
                :class="{
                  'has-image': imageUrl
                }"
                @dragover.prevent
                @drop.prevent="handleDrop"
                @click="triggerFileInput"
              >

                <input
                  ref="fileInput"
                  type="file"
                  accept="image/*"
                  class="hidden-input"
                  @change="handleFileChange"
                />


                <!-- LOADING -->

                <div
                  v-if="loading"
                  class="upload-loading"
                >

                  <div class="upload-spinner"></div>

                  <strong>
                    Загружаем изображение
                  </strong>

                  <span>
                    Подождите немного
                  </span>

                </div>


                <!-- EMPTY -->

                <div
                  v-else-if="!imageUrl"
                  class="upload-empty"
                >

                  <div class="upload-icon-wrapper">

                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M12 16V5"
                        stroke="currentColor"
                        stroke-width="1.7"
                        stroke-linecap="round"
                      />

                      <path
                        d="M8 9L12 5L16 9"
                        stroke="currentColor"
                        stroke-width="1.7"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />

                      <path
                        d="M5 14V18C5 18.55 5.45 19 6 19H18C18.55 19 19 18.55 19 18V14"
                        stroke="currentColor"
                        stroke-width="1.7"
                        stroke-linecap="round"
                      />
                    </svg>

                  </div>


                  <strong>
                    Добавьте обложку
                  </strong>

                  <span>
                    Перетащите изображение сюда
                    или нажмите для выбора
                  </span>

                  <small>
                    JPG, PNG · рекомендуется 16:9
                  </small>

                </div>


                <!-- IMAGE -->

                <div
                  v-else
                  class="image-preview"
                >

                  <img
                    :src="imageUrl"
                    alt="Обложка события"
                  />


                  <div class="image-overlay">

                    <button
                      type="button"
                      class="change-image-button"
                      @click.stop="triggerFileInput"
                    >
                      Изменить
                    </button>


                    <button
                      type="button"
                      class="remove-image-button"
                      @click.stop="removeImage"
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M6 7H18"
                          stroke="currentColor"
                          stroke-width="1.7"
                          stroke-linecap="round"
                        />

                        <path
                          d="M9 7V5H15V7"
                          stroke="currentColor"
                          stroke-width="1.7"
                          stroke-linecap="round"
                        />

                        <path
                          d="M8 7L9 19H15L16 7"
                          stroke="currentColor"
                          stroke-width="1.7"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>

                  </div>

                </div>

              </div>


              <!-- PREVIEW -->

              <div class="event-preview-card">

                <div class="preview-card-header">

                  <span>
                    Предпросмотр
                  </span>

                  <div class="preview-status">
                    Черновик
                  </div>

                </div>


                <div class="preview-card-body">

                  <div class="preview-date">

                    <strong>
                      {{ previewDay }}
                    </strong>

                    <span>
                      {{ previewMonth }}
                    </span>

                  </div>


                  <div class="preview-info">

                    <span class="preview-type">
                      Ивент
                    </span>

                    <h3>
                      {{
                        form.title
                        || "Название вашего события"
                      }}
                    </h3>

                    <p>
                      {{
                        form.description
                          ? shortDescription
                          : "Описание появится здесь после заполнения формы."
                      }}
                    </p>

                  </div>

                </div>


                <div class="preview-meta">

                  <div>

                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M12 21C12 21 18 15.8 18 10.5C18 6.91 15.31 4 12 4C8.69 4 6 6.91 6 10.5C6 15.8 12 21 12 21Z"
                        stroke="currentColor"
                        stroke-width="1.6"
                      />

                      <circle
                        cx="12"
                        cy="10"
                        r="2"
                        stroke="currentColor"
                        stroke-width="1.6"
                      />
                    </svg>

                    <span>
                      {{
                        selectedCity?.city
                        || selectedCity?.name
                        || "Город не выбран"
                      }}
                    </span>

                  </div>


                  <div>

                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M5 20V8L12 4L19 8V20"
                        stroke="currentColor"
                        stroke-width="1.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />

                      <path
                        d="M9 20V14H15V20"
                        stroke="currentColor"
                        stroke-width="1.6"
                      />
                    </svg>

                    <span>
                      {{
                        selectedCompany?.name
                        || selectedCompany?.company_name
                        || "Компания не выбрана"
                      }}
                    </span>

                  </div>

                </div>

              </div>


              <!-- SUBMIT -->

              <div class="publish-card">

                <div class="publish-info">

                  <div class="publish-icon">
                    ✓
                  </div>

                  <div>
                    <strong>
                      Почти готово
                    </strong>

                    <span>
                      Заполните все поля для отправки
                    </span>
                  </div>

                </div>


                <button
                  type="button"
                  class="event-button"
                  :disabled="!isValid || loadingSubmit"
                  @click="submitEvent"
                >

                  <template v-if="!loadingSubmit">

                    <span>
                      Отправить на модерацию
                    </span>

                    <svg
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M7 5L12 10L7 15"
                        stroke="currentColor"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                  </template>


                  <template v-else>

                    <span class="button-spinner"></span>

                    Отправляем...

                  </template>

                </button>

              </div>

            </div>

          </aside>

        </div>

      </div>

    </main>


    <Footer />

  </div>


  <!-- =========================================================
       GLOBAL LOADER
  ========================================================== -->

  <Transition name="overlay">
    <div
      v-if="loadingSubmit"
      class="overlay-loader"
    >
      <div class="loader-card">

        <div class="spinner"></div>

        <strong>
          Сохраняем ивент
        </strong>

        <span>
          Отправляем данные на модерацию
        </span>

      </div>
    </div>
  </Transition>

</template>


<script setup>

import {
  computed,
  reactive,
  ref,
  watch
} from "vue";

import {
  useRouter
} from "vue-router";

import {
  AnalyticsService,
  AnalyticsEvent
} from "../utils/AnalyticsService";

import DefaultHeader
  from "../components/CreateEventHeader.vue";

import Footer
  from "../components/MiniFooter.vue";

import CityAutocompleteForEvent
  from "../components/CityAutocompleteForEvent.vue";

import CompanyAutocompleteForEvent
  from "../components/profile/CompanyAutocompleteForEvent.vue";

import EventService
  from "../api/EventService.js";


const router =
  useRouter();


const loadingSubmit =
  ref(false);

const eventId =
  ref(
    crypto.randomUUID()
  );


const selectedCompany =
  ref(null);

const selectedCity =
  ref(null);


const snackbarMessage =
  ref("");

const snackbarError =
  ref(false);

const showSnackbarFlag =
  ref(false);


const fileInput =
  ref(null);

const imageUrl =
  ref("");

const loading =
  ref(false);


const form =
  reactive({
    title: "",
    description: "",
    dateOfEvent: "",
    imageURL: "",
    linkURL: "",
    cityID: "",
    companyID: ""
  });


/* ============================================================
   WATCHERS
============================================================ */

watch(
  selectedCity,
  value => {

    form.cityID =
      value?._id
      || "";

  }
);


watch(
  selectedCompany,
  value => {

    form.companyID =
      value?.company_id
      || "";

  }
);


/* ============================================================
   VALIDATION
============================================================ */

const isValid =
  computed(() => {

    return Boolean(
      form.title.trim()
      && form.description.trim()
      && form.dateOfEvent
      && form.imageURL
      && form.linkURL.trim()
      && form.cityID
      && form.companyID
    );

  });


/* ============================================================
   PREVIEW
============================================================ */

const shortDescription =
  computed(() => {

    const value =
      form.description.trim();

    if (
      value.length <= 110
    ) {
      return value;
    }

    return (
      value.slice(
        0,
        110
      )
      + "…"
    );

  });


const previewDate =
  computed(() => {

    if (
      !form.dateOfEvent
    ) {
      return null;
    }


    const date =
      new Date(
        `${form.dateOfEvent}T12:00:00`
      );


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return null;
    }


    return date;

  });


const previewDay =
  computed(() => {

    if (
      !previewDate.value
    ) {
      return "—";
    }


    return new Intl.DateTimeFormat(
      "ru-RU",
      {
        day: "2-digit"
      }
    ).format(
      previewDate.value
    );

  });


const previewMonth =
  computed(() => {

    if (
      !previewDate.value
    ) {
      return "ДАТА";
    }


    return new Intl.DateTimeFormat(
      "ru-RU",
      {
        month: "short"
      }
    )
      .format(
        previewDate.value
      )
      .replace(
        ".",
        ""
      )
      .toUpperCase();

  });


/* ============================================================
   SNACKBAR
============================================================ */

function showSnackbar(
  message,
  isError = false
) {

  snackbarMessage.value =
    message;

  snackbarError.value =
    isError;

  showSnackbarFlag.value =
    false;


  window.setTimeout(
    () => {

      showSnackbarFlag.value =
        true;

    },
    10
  );


  window.setTimeout(
    () => {

      showSnackbarFlag.value =
        false;

    },
    3000
  );

}


/* ============================================================
   IMAGE
============================================================ */

const triggerFileInput = () => {

  fileInput.value?.click();

};


const handleFileChange = event => {

  const file =
    event.target.files?.[0];


  if (file) {

    handleFileUpload(
      file
    );

  }

};


const handleDrop = event => {

  const file =
    event.dataTransfer
      ?.files?.[0];


  if (file) {

    handleFileUpload(
      file
    );

  }

};


const handleFileUpload =
  async file => {

    try {

      loading.value =
        true;


      const uploadedURL =
        await EventService
          .uploadEventImage(
            file,
            eventId.value
          );


      imageUrl.value =
        uploadedURL;

      form.imageURL =
        uploadedURL;


    } catch (error) {

      console.error(
        "❌ Ошибка загрузки изображения:",
        error
      );


      showSnackbar(
        "Не удалось загрузить изображение",
        true
      );


    } finally {

      loading.value =
        false;

    }

  };


const removeImage = () => {

  imageUrl.value =
    "";

  form.imageURL =
    "";


  if (
    fileInput.value
  ) {

    fileInput.value.value =
      "";

  }

};


/* ============================================================
   SUBMIT
============================================================ */

async function submitEvent() {

  if (
    !isValid.value
    || loadingSubmit.value
  ) {
    return;
  }


  try {

    loadingSubmit.value =
      true;


    const payload = {

      title:
        form.title.trim(),

      previewTitle:
        form.title.trim(),

      description:
        form.description.trim(),

      dateOfEvent:
        new Date(
          `${form.dateOfEvent}T12:00:00`
        ).getTime(),

      imageURL:
        form.imageURL,

      linkURL:
        form.linkURL.trim(),

      companyID:
        form.companyID,

      cityID:
        form.cityID,

      eventID:
        form.eventID
        || null
    };


    const result =
      await EventService
        .createOrUpdateEvent(
          payload
        );


    console.log(
      "✅ Event saved:",
      result
    );


    AnalyticsService.log(
      AnalyticsEvent.CREATE_EVENT
    );


    showSnackbar(
      "Ивент отправлен на модерацию"
    );


    /*
     * Небольшая задержка,
     * чтобы пользователь увидел успех.
     */

    window.setTimeout(
      () => {

        router.push(
          "/my-events"
        );

      },
      650
    );


  } catch (error) {

    console.error(
      "❌ Ошибка создания ивента:",
      error?.response?.data
      || error?.message
      || error
    );


    showSnackbar(
      error?.response?.data?.error
      || "Не удалось создать ивент",
      true
    );


  } finally {

    loadingSubmit.value =
      false;

  }

}

</script>


<style scoped>

* {
  box-sizing: border-box;
}


/* ============================================================
   PAGE
============================================================ */

.create-event-page {
  width: 100%;
  height: 100dvh;

  display: flex;
  flex-direction: column;

  overflow: hidden;

  background: #f4f6f9;
  color: #24272d;
}

.fixed-header {
  flex-shrink: 0;
}


.create-event-content {
  flex: 1;
  min-height: 0;

  overflow-y: auto;
  overflow-x: hidden;

  padding:
    48px
    24px
    90px;

  background:
    radial-gradient(
      circle at 14% 0%,
      rgba(40, 135, 247, 0.08),
      transparent 370px
    ),
    radial-gradient(
      circle at 88% 10%,
      rgba(124, 92, 231, 0.055),
      transparent 340px
    ),
    #f4f6f9;

  scrollbar-width: none;
}

.create-event-content::-webkit-scrollbar {
  display: none;
}

.create-event-container {
  width:
    100%;

  max-width:
    1180px;

  margin:
    0 auto;
}

.create-event-page > :deep(footer) {
  flex-shrink: 0;
}


/* ============================================================
   HEADING
============================================================ */

.page-heading {
  display: flex;

  align-items:
    flex-start;

  justify-content:
    space-between;

  gap:
    30px;

  margin-bottom:
    30px;
}


.page-label {
  display:
    block;

  margin-bottom:
    6px;

  color:
    #979da7;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    10px;

  letter-spacing:
    0.09em;

  text-transform:
    uppercase;
}


.page-heading h1 {
  margin:
    0;

  color:
    #22262d;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    30px;

  line-height:
    1.2;
}


.page-heading p {
  max-width:
    540px;

  margin:
    9px
    0
    0;

  color:
    #7c838e;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    13px;

  line-height:
    1.55;
}


.moderation-info {
  display:
    flex;

  align-items:
    center;

  gap:
    10px;

  padding:
    10px
    14px;

  background:
    rgba(
      255,
      255,
      255,
      0.72
    );

  border:
    1px solid
    rgba(
      31,
      44,
      62,
      0.065
    );

  border-radius:
    13px;

  box-shadow:
    0 6px 18px
    rgba(
      15,
      23,
      42,
      0.035
    );
}


.moderation-dot {
  width:
    8px;

  height:
    8px;

  flex-shrink:
    0;

  border-radius:
    50%;

  background:
    #ed9c38;

  box-shadow:
    0 0 0 4px
    rgba(
      237,
      156,
      56,
      0.1
    );
}


.moderation-info div {
  display:
    flex;

  flex-direction:
    column;

  gap:
    1px;
}


.moderation-info strong {
  color:
    #565c66;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    10px;
}


.moderation-info div span {
  color:
    #969ca5;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    8px;
}


/* ============================================================
   EDITOR LAYOUT
============================================================ */

.editor-layout {
  display:
    grid;

  grid-template-columns:
    minmax(
      0,
      1fr
    )
    390px;

  gap:
    24px;

  align-items:
    start;
}


.form-column {
  display:
    flex;

  flex-direction:
    column;

  gap:
    18px;
}


.preview-column {
  min-width:
    0;
}


.preview-sticky {
  position:
    sticky;

  top:
    20px;
}


/* ============================================================
   EDITOR CARD
============================================================ */

.editor-card {
  padding:
    25px;

  background:
    rgba(
      255,
      255,
      255,
      0.92
    );

  border:
    1px solid
    rgba(
      31,
      44,
      62,
      0.065
    );

  border-radius:
    20px;

  box-shadow:
    0 10px 28px
    rgba(
      15,
      23,
      42,
      0.04
    );
}


.card-heading {
  display:
    flex;

  align-items:
    center;

  gap:
    12px;

  margin-bottom:
    24px;
}


.card-heading-icon {
  width:
    42px;

  height:
    42px;

  flex-shrink:
    0;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  border-radius:
    13px;
}


.card-heading-icon svg {
  width:
    20px;

  height:
    20px;
}


.main-icon {
  color:
    #347fe7;

  background:
    rgba(
      52,
      127,
      231,
      0.09
    );
}


.date-icon {
  color:
    #805fd8;

  background:
    rgba(
      128,
      95,
      216,
      0.09
    );
}


.company-icon {
  color:
    #31a273;

  background:
    rgba(
      49,
      162,
      115,
      0.09
    );
}


.card-heading h2 {
  margin:
    0;

  color:
    #30343b;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    14px;
}


.card-heading p {
  margin:
    3px
    0
    0;

  color:
    #a0a5ae;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;
}


/* ============================================================
   FORM
============================================================ */

.form-group {
  display:
    flex;

  flex-direction:
    column;

  gap:
    8px;

  margin-top:
    18px;
}


.form-group:first-of-type {
  margin-top:
    0;
}


.label-row {
  display:
    flex;

  justify-content:
    space-between;

  align-items:
    center;

  gap:
    10px;
}


.form-group label,
.custom-field-label {
  color:
    #626a75;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    10px;
}


.field-counter {
  color:
    #a3a8b0;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    8px;

  transition:
    color
    0.2s ease;
}


.field-counter.warning {
  color:
    #e18a3b;
}


.form-group input,
.form-group textarea {
  width:
    100%;

  padding:
    13px
    14px;

  color:
    #343941;

  background:
    #f8f9fb;

  border:
    1px solid
    rgba(
      31,
      44,
      62,
      0.08
    );

  border-radius:
    12px;

  outline:
    none;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    12px;

  line-height:
    1.5;

  transition:
    background-color
    0.2s ease,
    border-color
    0.2s ease,
    box-shadow
    0.2s ease;
}


.form-group textarea {
  resize:
    vertical;

  min-height:
    150px;
}


.form-group input::placeholder,
.form-group textarea::placeholder {
  color:
    #b1b6bf;
}


.form-group input:focus,
.form-group textarea:focus {
  background:
    #ffffff;

  border-color:
    rgba(
      52,
      127,
      231,
      0.55
    );

  box-shadow:
    0 0 0 3px
    rgba(
      52,
      127,
      231,
      0.08
    );
}


.two-column-fields {
  display:
    grid;

  grid-template-columns:
    0.75fr
    1.25fr;

  gap:
    14px;
}


.two-column-fields
.form-group {
  margin-top:
    0;
}


.input-with-icon {
  position:
    relative;
}


.input-with-icon svg {
  position:
    absolute;

  top:
    50%;

  left:
    13px;

  width:
    15px;

  height:
    15px;

  color:
    #9199a4;

  transform:
    translateY(-50%);

  pointer-events:
    none;
}


.input-with-icon input {
  padding-left:
    38px;
}


/* ============================================================
   AUTOCOMPLETE
============================================================ */

.autocomplete-field {
  display:
    flex;

  flex-direction:
    column;

  gap:
    8px;

  margin-top:
    18px;
}


.autocomplete-field:first-of-type {
  margin-top:
    0;
}


/* ============================================================
   IMAGE UPLOAD
============================================================ */

.preview-label-row {
  display:
    flex;

  align-items:
    center;

  justify-content:
    space-between;

  margin:
    0
    3px
    9px;
}


.preview-label {
  color:
    #69717c;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    10px;
}


.image-ready {
  display:
    inline-flex;

  align-items:
    center;

  gap:
    5px;

  color:
    #4b9e73;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    8px;
}


.image-ready span {
  width:
    5px;

  height:
    5px;

  border-radius:
    50%;

  background:
    #3bb979;
}


.image-upload-card {
  position:
    relative;

  width:
    100%;

  aspect-ratio:
    16 / 10;

  overflow:
    hidden;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  cursor:
    pointer;

  background:
    rgba(
      255,
      255,
      255,
      0.78
    );

  border:
    1.5px
    dashed
    rgba(
      86,
      105,
      132,
      0.22
    );

  border-radius:
    20px;

  box-shadow:
    0 9px 26px
    rgba(
      15,
      23,
      42,
      0.04
    );

  transition:
    border-color
    0.22s ease,
    background-color
    0.22s ease,
    transform
    0.22s ease,
    box-shadow
    0.22s ease;
}


.image-upload-card:not(.has-image):hover {
  transform:
    translateY(-2px);

  background:
    #ffffff;

  border-color:
    rgba(
      52,
      127,
      231,
      0.42
    );

  box-shadow:
    0 14px 34px
    rgba(
      52,
      127,
      231,
      0.08
    );
}


.image-upload-card.has-image {
  border:
    none;
}


.hidden-input {
  display:
    none;
}


.upload-empty {
  display:
    flex;

  flex-direction:
    column;

  align-items:
    center;

  justify-content:
    center;

  padding:
    30px;

  text-align:
    center;
}


.upload-icon-wrapper {
  width:
    50px;

  height:
    50px;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  margin-bottom:
    13px;

  color:
    #347fe7;

  background:
    rgba(
      52,
      127,
      231,
      0.085
    );

  border-radius:
    15px;

  transition:
    transform
    0.2s ease;
}


.image-upload-card:hover
.upload-icon-wrapper {
  transform:
    translateY(-2px);
}


.upload-icon-wrapper svg {
  width:
    22px;

  height:
    22px;
}


.upload-empty strong {
  color:
    #444b55;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    11px;
}


.upload-empty span {
  max-width:
    240px;

  margin-top:
    5px;

  color:
    #969da7;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;

  line-height:
    1.5;
}


.upload-empty small {
  margin-top:
    11px;

  color:
    #b1b6be;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    8px;
}


/* ============================================================
   IMAGE PREVIEW
============================================================ */

.image-preview {
  position:
    absolute;

  inset:
    0;
}


.image-preview img {
  width:
    100%;

  height:
    100%;

  display:
    block;

  object-fit:
    cover;
}


.image-overlay {
  position:
    absolute;

  inset:
    0;

  display:
    flex;

  align-items:
    flex-end;

  justify-content:
    flex-end;

  gap:
    7px;

  padding:
    13px;

  opacity:
    0;

  background:
    linear-gradient(
      to top,
      rgba(
        0,
        0,
        0,
        0.48
      ),
      transparent
      55%
    );

  transition:
    opacity
    0.2s ease;
}


.image-preview:hover
.image-overlay {
  opacity:
    1;
}


.change-image-button {
  height:
    34px;

  padding:
    0
    13px;

  color:
    #ffffff;

  background:
    rgba(
      18,
      22,
      28,
      0.62
    );

  border:
    1px solid
    rgba(
      255,
      255,
      255,
      0.17
    );

  border-radius:
    10px;

  backdrop-filter:
    blur(10px);

  cursor:
    pointer;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    9px;
}


.remove-image-button {
  width:
    34px;

  height:
    34px;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  color:
    #ffffff;

  background:
    rgba(
      225,
      68,
      68,
      0.82
    );

  border:
    none;

  border-radius:
    10px;

  cursor:
    pointer;
}


.remove-image-button svg {
  width:
    15px;

  height:
    15px;
}


/* ============================================================
   UPLOAD LOADING
============================================================ */

.upload-loading {
  display:
    flex;

  flex-direction:
    column;

  align-items:
    center;

  color:
    #8c939e;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;
}


.upload-loading strong {
  margin-top:
    12px;

  color:
    #555c66;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    10px;
}


.upload-loading span {
  margin-top:
    3px;
}


.upload-spinner {
  width:
    28px;

  height:
    28px;

  border:
    2px solid
    rgba(
      52,
      127,
      231,
      0.15
    );

  border-top-color:
    #347fe7;

  border-radius:
    50%;

  animation:
    spin
    0.75s
    linear
    infinite;
}


/* ============================================================
   EVENT MINI PREVIEW
============================================================ */

.event-preview-card {
  margin-top:
    17px;

  overflow:
    hidden;

  background:
    rgba(
      255,
      255,
      255,
      0.92
    );

  border:
    1px solid
    rgba(
      31,
      44,
      62,
      0.065
    );

  border-radius:
    18px;

  box-shadow:
    0 10px 28px
    rgba(
      15,
      23,
      42,
      0.04
    );
}


.preview-card-header {
  display:
    flex;

  align-items:
    center;

  justify-content:
    space-between;

  padding:
    12px
    14px;

  border-bottom:
    1px solid
    rgba(
      31,
      44,
      62,
      0.055
    );

  color:
    #9aa0aa;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    8px;

  text-transform:
    uppercase;

  letter-spacing:
    0.06em;
}


.preview-status {
  padding:
    4px
    7px;

  color:
    #a17434;

  background:
    rgba(
      237,
      156,
      56,
      0.08
    );

  border-radius:
    7px;
}


.preview-card-body {
  display:
    flex;

  align-items:
    flex-start;

  gap:
    13px;

  padding:
    15px;
}


.preview-date {
  width:
    47px;

  height:
    50px;

  flex-shrink:
    0;

  display:
    flex;

  flex-direction:
    column;

  align-items:
    center;

  justify-content:
    center;

  background:
    #f4f6f9;

  border:
    1px solid
    rgba(
      31,
      44,
      62,
      0.05
    );

  border-radius:
    12px;
}


.preview-date strong {
  color:
    #353a42;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    16px;

  line-height:
    1;
}


.preview-date span {
  margin-top:
    3px;

  color:
    #888f99;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    7px;
}


.preview-info {
  min-width:
    0;
}


.preview-type {
  display:
    block;

  margin-bottom:
    4px;

  color:
    #a0a6af;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    7px;

  letter-spacing:
    0.06em;

  text-transform:
    uppercase;
}


.preview-info h3 {
  margin:
    0;

  overflow:
    hidden;

  color:
    #343941;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    12px;

  line-height:
    1.35;

  text-overflow:
    ellipsis;

  white-space:
    nowrap;
}


.preview-info p {
  display:
    -webkit-box;

  margin:
    5px
    0
    0;

  overflow:
    hidden;

  color:
    #8b929d;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    8px;

  line-height:
    1.5;

  -webkit-box-orient:
    vertical;

  -webkit-line-clamp:
    2;
}


.preview-meta {
  display:
    flex;

  flex-direction:
    column;

  gap:
    7px;

  padding:
    0
    15px
    14px;
}


.preview-meta div {
  min-width:
    0;

  display:
    flex;

  align-items:
    center;

  gap:
    6px;

  color:
    #89909a;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    8px;
}


.preview-meta svg {
  width:
    12px;

  height:
    12px;

  flex-shrink:
    0;
}


.preview-meta span {
  overflow:
    hidden;

  text-overflow:
    ellipsis;

  white-space:
    nowrap;
}


/* ============================================================
   PUBLISH
============================================================ */

.publish-card {
  margin-top:
    17px;

  padding:
    16px;

  background:
    rgba(
      255,
      255,
      255,
      0.92
    );

  border:
    1px solid
    rgba(
      31,
      44,
      62,
      0.065
    );

  border-radius:
    18px;

  box-shadow:
    0 10px 28px
    rgba(
      15,
      23,
      42,
      0.04
    );
}


.publish-info {
  display:
    flex;

  align-items:
    center;

  gap:
    10px;

  margin-bottom:
    13px;
}


.publish-icon {
  width:
    34px;

  height:
    34px;

  flex-shrink:
    0;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  color:
    #ffffff;

  background:
    linear-gradient(
      135deg,
      #42b878,
      #2ea46a
    );

  border-radius:
    10px;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    11px;
}


.publish-info div:last-child {
  display:
    flex;

  flex-direction:
    column;

  gap:
    2px;
}


.publish-info strong {
  color:
    #4e555e;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    10px;
}


.publish-info span {
  color:
    #9aa0a9;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    8px;
}


.event-button {
  width:
    100%;

  min-height:
    44px;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  gap:
    8px;

  padding:
    0
    16px;

  color:
    #ffffff;

  background:
    linear-gradient(
      135deg,
      #2887f7,
      #436ee8
    );

  border:
    0;

  border-radius:
    12px;

  box-shadow:
    0 8px 18px
    rgba(
      40,
      135,
      247,
      0.2
    );

  cursor:
    pointer;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    10px;

  transition:
    transform
    0.2s ease,
    box-shadow
    0.2s ease,
    opacity
    0.2s ease;
}


.event-button:hover:not(:disabled) {
  transform:
    translateY(-1px);

  box-shadow:
    0 11px 23px
    rgba(
      40,
      135,
      247,
      0.27
    );
}


.event-button:disabled {
  cursor:
    not-allowed;

  opacity:
    0.38;

  box-shadow:
    none;
}


.event-button svg {
  width:
    15px;

  height:
    15px;
}


.button-spinner {
  width:
    14px;

  height:
    14px;

  border:
    2px solid
    rgba(
      255,
      255,
      255,
      0.35
    );

  border-top-color:
    #ffffff;

  border-radius:
    50%;

  animation:
    spin
    0.75s
    linear
    infinite;
}


/* ============================================================
   OVERLAY
============================================================ */

.overlay-loader {
  position:
    fixed;

  inset:
    0;

  z-index:
    99999;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  background:
    rgba(
      13,
      18,
      28,
      0.38
    );

  backdrop-filter:
    blur(8px);
}


.loader-card {
  min-width:
    220px;

  display:
    flex;

  flex-direction:
    column;

  align-items:
    center;

  padding:
    28px
    34px;

  background:
    rgba(
      255,
      255,
      255,
      0.96
    );

  border:
    1px solid
    rgba(
      255,
      255,
      255,
      0.5
    );

  border-radius:
    20px;

  box-shadow:
    0 20px 60px
    rgba(
      0,
      0,
      0,
      0.18
    );
}


.spinner {
  width:
    38px;

  height:
    38px;

  border:
    3px solid
    rgba(
      52,
      127,
      231,
      0.15
    );

  border-top-color:
    #347fe7;

  border-radius:
    50%;

  animation:
    spin
    0.8s
    linear
    infinite;
}


.loader-card strong {
  margin-top:
    15px;

  color:
    #414750;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    11px;
}


.loader-card span {
  margin-top:
    4px;

  color:
    #949ba5;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;
}


@keyframes spin {

  to {
    transform:
      rotate(
        360deg
      );
  }

}


/* ============================================================
   SNACKBAR
============================================================ */

.snackbar {
  position:
    fixed;

  left:
    50%;

  bottom:
    34px;

  z-index:
    100000;

  min-width:
    290px;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  gap:
    9px;

  padding:
    12px
    18px;

  color:
    #ffffff;

  border-radius:
    14px;

  box-shadow:
    0 16px 38px
    rgba(
      0,
      0,
      0,
      0.22
    );

  transform:
    translateX(
      -50%
    );

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    11px;
}


.snackbar-success {
  background:
    rgba(
      31,
      42,
      37,
      0.96
    );
}


.snackbar-error {
  background:
    rgba(
      68,
      31,
      33,
      0.96
    );
}


.snackbar-icon {
  width:
    23px;

  height:
    23px;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  color:
    #ffffff;

  border-radius:
    50%;

  background:
    #3dbf78;

  font-size:
    10px;
}


.snackbar-error
.snackbar-icon {
  background:
    #e15b61;
}


.snackbar-enter-active,
.snackbar-leave-active {
  transition:
    opacity
    0.2s ease,
    transform
    0.22s ease;
}


.snackbar-enter-from,
.snackbar-leave-to {
  opacity:
    0;

  transform:
    translateX(-50%)
    translateY(10px);
}


.overlay-enter-active,
.overlay-leave-active {
  transition:
    opacity
    0.2s ease;
}


.overlay-enter-from,
.overlay-leave-to {
  opacity:
    0;
}


/* ============================================================
   DARK
============================================================ */

html[data-theme="dark"]
.create-event-page {
  color:
    #f2f2f4;

  background:
    #18191c;
}


html[data-theme="dark"]
.create-event-content {
  background:
    radial-gradient(
      circle at 14% 0%,
      rgba(40, 135, 247, 0.07),
      transparent 370px
    ),
    radial-gradient(
      circle at 88% 10%,
      rgba(124, 92, 231, 0.06),
      transparent 340px
    ),
    #18191c;
}


html[data-theme="dark"]
.page-heading h1 {
  color:
    #f2f3f5;
}


html[data-theme="dark"]
.page-heading p {
  color:
    #939aa5;
}


html[data-theme="dark"]
.page-label {
  color:
    #747b85;
}


html[data-theme="dark"]
.moderation-info,
html[data-theme="dark"]
.editor-card,
html[data-theme="dark"]
.event-preview-card,
html[data-theme="dark"]
.publish-card,
html[data-theme="dark"]
.image-upload-card {
  background:
    #232428;

  border-color:
    rgba(
      255,
      255,
      255,
      0.065
    );

  box-shadow:
    0 12px 30px
    rgba(
      0,
      0,
      0,
      0.18
    );
}


html[data-theme="dark"]
.card-heading h2 {
  color:
    #f0f1f3;
}


html[data-theme="dark"]
.card-heading p,
html[data-theme="dark"]
.form-group label,
html[data-theme="dark"]
.custom-field-label {
  color:
    #9299a4;
}


html[data-theme="dark"]
.form-group input,
html[data-theme="dark"]
.form-group textarea {
  color:
    #eeeeef;

  background:
    #2d2f34;

  border-color:
    rgba(
      255,
      255,
      255,
      0.07
    );
}


html[data-theme="dark"]
.form-group input:focus,
html[data-theme="dark"]
.form-group textarea:focus {
  background:
    #303238;

  border-color:
    rgba(
      69,
      132,
      231,
      0.5
    );
}


html[data-theme="dark"]
.form-group input::placeholder,
html[data-theme="dark"]
.form-group textarea::placeholder {
  color:
    #717781;
}


html[data-theme="dark"]
.image-upload-card:not(.has-image):hover {
  background:
    #282a2f;
}


html[data-theme="dark"]
.upload-empty strong,
html[data-theme="dark"]
.upload-loading strong,
html[data-theme="dark"]
.publish-info strong,
html[data-theme="dark"]
.preview-info h3 {
  color:
    #e6e7ea;
}


html[data-theme="dark"]
.preview-card-header {
  border-bottom-color:
    rgba(
      255,
      255,
      255,
      0.06
    );
}


html[data-theme="dark"]
.preview-date {
  background:
    #303238;

  border-color:
    rgba(
      255,
      255,
      255,
      0.055
    );
}


html[data-theme="dark"]
.preview-date strong {
  color:
    #eceef1;
}


html[data-theme="dark"]
.loader-card {
  background:
    #25272c;

  border-color:
    rgba(
      255,
      255,
      255,
      0.08
    );
}


html[data-theme="dark"]
.loader-card strong {
  color:
    #eeeeef;
}


/* ============================================================
   TABLET
============================================================ */

@media (
  max-width:
  1000px
) {

  .editor-layout {
    grid-template-columns:
      1fr
      330px;
  }

}


/* ============================================================
   MOBILE / SMALL TABLET
============================================================ */

@media (
  max-width:
  820px
) {

  .create-event-content {
    padding:
      34px
      18px
      70px;
  }


  .editor-layout {
    grid-template-columns:
      1fr;
  }


  .preview-sticky {
    position:
      static;
  }


  .preview-column {
    order:
      -1;
  }


  .two-column-fields {
    grid-template-columns:
      1fr;
  }

}


/* ============================================================
   MOBILE
============================================================ */

@media (
  max-width:
  600px
) {

  .create-event-content {
    padding:
      26px
      14px
      60px;
  }


  .page-heading {
    flex-direction:
      column;

    gap:
      15px;

    margin-bottom:
      22px;
  }


  .page-heading h1 {
    font-size:
      25px;
  }


  .page-heading p {
    font-size:
      12px;
  }


  .moderation-info {
    width:
      100%;
  }


  .editor-card {
    padding:
      19px
      16px;

    border-radius:
      17px;
  }


  .card-heading {
    margin-bottom:
      19px;
  }


  .image-upload-card {
    border-radius:
      17px;
  }


  .event-preview-card,
  .publish-card {
    border-radius:
      16px;
  }


  .snackbar {
    width:
      calc(
        100% - 28px
      );

    min-width:
      0;
  }

}


/* ============================================================
   REDUCED MOTION
============================================================ */

@media (
  prefers-reduced-motion:
  reduce
) {

  .image-upload-card,
  .event-button,
  .upload-icon-wrapper,
  .snackbar-enter-active,
  .snackbar-leave-active,
  .overlay-enter-active,
  .overlay-leave-active {
    transition:
      none;
  }


  .spinner,
  .upload-spinner,
  .button-spinner {
    animation:
      none;
  }

}

</style>